import bgIcon from './default.png';
import abstraction from './abstraction.png';
import balloon from './balloon.png';
import kapadokya from './kapadokya.png';
import ocean from './ocean.png';
import canyon from './canyon.png';
import clouds from './clouds.png';
import plant from './plant.png';
import halfMoon from './half-moon.png';
import moon from './moon.png';
import rocks from './rocks.png';
import flowers from './flowers.png';
import night from './night.png';
import pinkTree from './pink-tree.png';
import starrySky from './starry-sky.png';
import yacht from './yacht.png';

const data = [
  { id: '0', image: bgIcon },
  { id: '1', image: flowers },
  { id: '2', image: night },
  { id: '3', image: pinkTree },
  { id: '4', image: halfMoon },
  { id: '5', image: plant },
  { id: '6', image: clouds },
  { id: '7', image: rocks },
  { id: '8', image: abstraction },
  { id: '9', image: moon },
  { id: '10', image: yacht },
  { id: '11', image: balloon },
  { id: '12', image: canyon },
  { id: '13', image: ocean },
  { id: '14', image: kapadokya },
  { id: '15', image: starrySky },
];

export default data;
